export default __webpack_public_path__ + "static/N0027-987f8f77fb0f863836e057b537ce1693.png";